<template>
  <header id="header" :class="type">
    <a href="https://www.ncbank.co.jp/" target="_blank" class="logo" v-if="type === 'search'">
      <img src="../../assets/images/common/logo.png" alt="西日本シティ銀行">
    </a>
    <a href="https://www.ncbank.co.jp/" class="logo" v-else>
      <img src="../../assets/images/common/logo.png" alt="西日本シティ銀行">
    </a>
    <div class="header_menu sp_none">
      <ul class="pc_menus">
        <li><a href="https://www.ncbank.co.jp/">個人のお客さま</a></li>
        <li><a href="https://www.ncbank.co.jp/hojin/">法人・個人事業主のお客さま</a></li>
        <li><a href="https://www.ncbank.co.jp/corporate/">西日本シティ銀行について</a></li>
        <li class="service">
          <div class="header_service">
            <span>サービス</span>
            <div class="service_menu">
              <a :href="atmTopUrl" class="service_menu_item">
                <img src="../../assets/images/common/service/service_atm.svg" alt="店舗・ATM">
                <span>店舗・ATM</span>
              </a>
              <a href="https://www2.ncbank.co.jp/request_brochure/?_gl=1*11cb2tu*_gcl_aw*R0NMLjE2MTA1ODU1MzMuQ2owS0NRaUEwZnJfQlJEYUFSSXNBQUJ3NEV2Sk41eEIyaDdrd3k2a2pVWGNBZFpObHA1SjZLWjk4RWkxNUpqOGVIVk9EMmFfekdSOEp0d2FBalNPRUFMd193Y0I.&amp;_ga=2.95795999.2036042818.1612140614-1822495815.1611814134&amp;_gac=1.184586843.1610585532.Cj0KCQiA0fr_BRDaARIsAABw4EvJN5xB2h7kwy6kjUXcAdZNlp5J6KZ98Ei15Jj8eHVOD2a_zGR8JtwaAjSOEALw_wcB" class="service_menu_item">
                <img src="../../assets/images/common/service/service_document.svg" alt="資料請求">
                <span>資料請求</span>
              </a>
              <a href="https://www.ncbank.co.jp/otoiawase/" class="service_menu_item">
                <img src="../../assets/images/common/service/service_contact.svg" alt="お問い合わせ">
                <span>お問い合わせ</span>
              </a>
              <a class="service_menu_item" @click="showWebServiceBooks()">
                <img src="../../assets/images/common/service/service_books.svg" alt="WEB帳票作成">
                <span>WEB帳票作成</span>
              </a>
              <div class="service_menu_item" @click="showSearchInput()">
                <img src="../../assets/images/common/service/service_search.svg" alt="検索">
                <span>検索</span>
              </div>
              <div class="site_search" :class="showSearchInputFlag ? 'search_show': ''">
                <div class="site_search_input_wrapper">
                  <form name="search_form" action="https://sitesearch.ncbank.co.jp/" method="GET" onsubmit="mysearch(this);">
                    <div class="site_search_input">
                      <input type="text" name="kw" value="" class="iSearchAssist" placeholder="サイト内検索" autocomplete="off">
                      <input type="hidden" name="ie" value="u">
                      <button type="submit">検索</button>
                    </div>
                  </form>
                  <div class="site_search_close" @click="hideSearchInput()">
                    <img src="../../assets/images/common/close_orange.svg" alt="閉じる">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="menu_function">
        <ul>
          <li><a href="https://www.ncbank.co.jp/saiyo_joho/?_gl=1*18suyny*_gcl_aw*R0NMLjE2MTE1MzYzNzkuQ2owS0NRaUEwclNBQmhEbEFSSXNBSnRqZkNmbDc5YnFMdkNibTRLMDNCODVsX2ZRYzlVSUpBLXpNYllHNlU3YmlSM0RxNVZ6NzNJYlk3TWFBbUVrRUFMd193Y0I.&_ga=2.32949239.814046079.1611536368-1384539511.1608796340&_gac=1.61849054.1611536379.Cj0KCQiA0rSABhDlARIsAJtjfCfl79bqLvCbm4K03B85l_fQc9UIJA-zMbYG6U7biR3Dq5Vz73IbY7MaAmEkEALw_wcB/">採用情報</a></li>
          <li><a href="https://www.ncbank.co.jp/sitemap/?_gl=1*cs3ijz*_gcl_aw*R0NMLjE2MTE1MzYzNzkuQ2owS0NRaUEwclNBQmhEbEFSSXNBSnRqZkNmbDc5YnFMdkNibTRLMDNCODVsX2ZRYzlVSUpBLXpNYllHNlU3YmlSM0RxNVZ6NzNJYlk3TWFBbUVrRUFMd193Y0I.&_ga=2.19457137.814046079.1611536368-1384539511.1608796340&_gac=1.12106054.1611536379.Cj0KCQiA0rSABhDlARIsAJtjfCfl79bqLvCbm4K03B85l_fQc9UIJA-zMbYG6U7biR3Dq5Vz73IbY7MaAmEkEALw_wcB">サイトマップ</a></li>
          <li><a href="https://www.ncbank.co.jp/kabunushi_toshika/annual_report/">English</a></li>
        </ul>
        <div class="function_buttons">
          <a href="https://www.ncbank.co.jp/hiraku/" type="button" class="account_open">口座開設</a>
          <div class="login_button">
            <button type="button" class="login" @click="toggleLoginMenu()">ログイン</button>
            <div class="login_popover" v-show="showLoginMenu">
              <div class="login_wrapper">
                <div class="login_type">
                  <div>個人さま向け<br>NCBダイレクト</div>
                  <a href="https://www.ncb-direct.ncbank.co.jp/ib/index.do?PT=BS&amp;CCT0080=0190&amp;_ga=2.17564476.488170762.1636623597-1624690786.1634090021" target="_blank">ログイン</a>
                </div>
                <div class="login_type">
                  <div>法人さま向け<br>NCBビジネスステーション</div>
                  <a href="https://www.0190.houjinportal.anser.ne.jp/" target="_blank">ログイン</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header_functions">
      <a href="https://www.ncbank.co.jp/hiraku/" class="icon account">
        <img src="../../assets/images/common/account.svg" alt="口座開設">
        <span>口座開設</span>
      </a>
      <div class="icon login" @click="toggleSpLoginMenu()">
        <img src="../../assets/images/common/login.svg" alt="ログイン">
        <span>ログイン</span>
        <div class="sp_login_popover" v-show="showSpLoginMenu">
          <div class="sp_login_wrapper">
            <div class="sp_login_type">
              <div>個人さま向け<br>NCBダイレクト</div>
              <a href="https://www.ncb-direct.ncbank.co.jp/ib/index.do?PT=BS&amp;CCT0080=0190" target="_blank">ログイン</a>
            </div>
            <div class="sp_login_type">
              <div>法人さま向け<br>NCBビジネスステーション</div>
              <a href="https://www.0190.houjinportal.anser.ne.jp/" target="_blank">ログイン</a>
            </div>
          </div>
        </div>
      </div>
      <div class="icon menu normal" @click="showSideMenu()" v-if="!isOpen">
        <img src="../../assets/images/common/icon-sp-menu.svg" alt="メニュー">
        <span>メニュー</span>
      </div>
      <div class="icon menu" @click="hideSideMenu()" v-if="isOpen">
        <img src="../../assets/images/common/close_orange.svg" alt="閉じる">
        <span>閉じる</span>
      </div>
    </div>
    <v-ons-dialog :visible.sync="visibleServiceBooks" id="pc_serviceBooks" animation="none" cancelable>
      <div class="service_book_wrapper">
        <p>ご利用するサービスを選択ください。</p>
        <div class="service_book_buttons">
          <a href="https://www.ncbank.co.jp/service/denpyousakuseiweb/" v-ripple><span>伝票作成WEBサービス</span></a>
          <a href="https://www.ncbank.co.jp/hojin/efficiency/henkoutodoke_sakuseiweb/?_ga=2.262993739.671902534.1637380079-1624690786.1634090021" v-ripple><span>法人・団体用 変更届作成WEBサービス</span></a>
        </div>
      </div>
    </v-ons-dialog>
  </header>
</template>

<script>
import store from '../../store/store';

export default {
  name: 'Header',
  components: {
  },
  directives: {
  },
  props: {
    pageType: String
  },
  data() {
    return {
      showSearchInputFlag: false,
      showLoginMenu: false,
      showSpLoginMenu: false,
      type: this.pageType,
      visibleServiceBooks: false,
      atmTopUrl: `${location.origin}/atm/`,
    };
  },
  computed: {
    isOpen: function() {
      return store.state.showMenu;
    },
    isMobile: function() {
      return store.state.isMobile;
    }
  },
  watch: {
    isOpen(value) {
      if (value) {
        this.showSpLoginMenu = false;
      }
    },
    showSpLoginMenu(value) {
      if (value) {
        store.dispatch('updateShowMenu', false);
      }
    },
    isMobile(newVal, oldVal) {
      if (newVal) {
        this.visibleServiceBooks = false;
      }
    }
  },
  methods: {
    /**
     * サイドメニューを表示します
     */
    showSideMenu() {
      store.dispatch('updateShowMenu', true);
    },
    /**
     * サイドメニューを非表示にします
     */
    hideSideMenu() {
      store.dispatch('updateShowMenu', false);
    },
    /**
     * サイト内検索を表示します
     */
    showSearchInput() {
      this.showSearchInputFlag = true;
    },
    /**
     * サイト内検索を非表示にします
     */
    hideSearchInput() {
      this.showSearchInputFlag = false;
    },
    /**
     * PCログインメニューの表示を切り替えます
     */
    toggleLoginMenu() {
      this.showLoginMenu = !this.showLoginMenu;
    },
    /**
     * SPログインメニューの表示を切り替えます
     */
    toggleSpLoginMenu() {
      this.showSpLoginMenu = !this.showSpLoginMenu;
    },
    /**
     * ルートへ遷移します
     */
    hrefRoot() {
      this.$router.replace({name: 'Search', params: {animation: 'none'}});
    },
    /**
     * WEB帳簿作成ダイアログを表示します
     */
    showWebServiceBooks() {
      this.visibleServiceBooks = true;
    },
    /**
     * サイト内検索をサブミットします（移植）
     */
    mysearch(obj) {
      let ActionProtcol;
      if (obj.action.indexOf('https:') === 0) {
        ActionProtcol = 'https://';
      } else {
        ActionProtcol = 'http://';
      }

      const url = ActionProtcol + 'sitesearch.ncbank.co.jp/?ref=' + this.URLencode(location.href) + '&kw=' + this.URLencode(obj.kw.value) + '&ie=' + obj.ie.value + '&by=js';
      document.location.href = url;
      return false;
    },
    /**
     * URLをエンコードします（移植）
     */
    URLencode(str) {
      let i;
      let encoded_str;
      let char_code;
      let padded_str;
      encoded_str = "";

      for (i = 0; i < str.length; i++) {
        char_code = str.charCodeAt(i);
        if (char_code == 0x20){
          encoded_str += "+";
        } else {
          if (((0x30 <= char_code) && (char_code <= 0x39)) || ((0x41 <= char_code) && (char_code <= 0x5a)) || ((0x61 <= char_code) && (char_code <= 0x7a))) {
            encoded_str += str.charAt(i);
          } else if ((char_code == 0x2a) || (char_code == 0x2e) || (char_code == 0x2d) || (char_code == 0x5f)) {
            encoded_str += str.charAt(i);
          } else {
            if ( char_code > 0xffff ) {
              encoded_str += "%" + ((char_code >> 18) | 0xf0).toString(16).toUpperCase();
              encoded_str += "%" + (((char_code >> 12) & 0x3f) | 0x80).toString(16).toUpperCase();
              encoded_str += "%" + (((char_code >> 6) & 0x3f) | 0x80).toString(16).toUpperCase();
              encoded_str += "%" + ((char_code & 0x3f) | 0x80).toString(16).toUpperCase();
            }
            else if ( char_code > 0x7ff ) {
              encoded_str += "%" + ((char_code >> 12) | 0xe0).toString(16).toUpperCase();
              encoded_str += "%" + (((char_code >> 6) & 0x3f) | 0x80).toString(16).toUpperCase();
              encoded_str += "%" + ((char_code & 0x3f) | 0x80).toString(16).toUpperCase();
            }
            else if ( char_code > 0x7f ) {
              encoded_str += "%" + (((char_code >> 6) & 0x1f) | 0xc0).toString(16).toUpperCase();
              encoded_str += "%" + ((char_code & 0x3f) | 0x80).toString(16).toUpperCase();
            }
            else {
              padded_str = "0" + char_code.toString(16).toUpperCase();
              encoded_str += "%" + padded_str.substr(padded_str.length - 2, 2);
            }
          }
        }
      }

      return encoded_str;
    },
  },
  mounted: function() {
    
  }
}
</script>
<style lang="scss" scoped>
header#header {
  height: 104px;
  background: #fff;
  padding: 16px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
  position: absolute;
  top: 0;
  width: 100%;
  border-bottom: solid 2px #EF7800;

  @media #{$small} {
    height: 56px;
    padding: 0 psd(12) 0 psd(20);
    position: absolute; 
    top: 0;
    width: 100%;
    z-index: 2;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
  }

  &.map {
    height: 80px;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 3;

    @media #{$small} {
      height: 48px;
    }

    .header_menu {
      .menu_function {
        justify-content: center;

        ul {
          display: none;
        }
      }
    }
  }

  .logo {
    appearance: none;
    height: auto;
    max-height: 76px;

    @media #{$small} {
      height: 100%;
      max-height: none;
      height: 100%;
      padding: 4px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-right: 10px;
    }

    img {
      display: block;
      width: 100%;

      @media #{$small} {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }

  // PC menu
  .header_menu {
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    height: 100%;

    ul.pc_menus {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      li {
        margin-right: 40px;

        &:last-of-type {
          margin-right: 0;
        }

        a {
          display: block;
          font-size: 13px;
          color: #5C5C5C;
          font-weight: 600;
          transition: color 0.2s ease 0s;

          &:hover {
            cursor: pointer;
            color: #FE6B01;
            transition: color 0.2s ease 0s;
          }
        }

        &.service {
          position: relative;
          
          .header_service {
            display: block;
            font-size: 13px;
            color: #5C5C5C;
            font-weight: 600;
            position: relative;

            &:hover {
              >span {
                cursor: pointer;
                color: #FE6B01;
                padding-bottom: 10px;

                +.service_menu {
                  display: flex;
                }
              }
            }
          }

          .service_menu {
            width: auto;
            position: absolute;
            top: calc(100% + 8px);
            bottom: auto;
            left: 50%;
            right: auto;
            margin: auto;
            background: #FFFFFF;
            display: none;
            justify-content: space-between;
            align-items: flex-start;
            transform: translateX(-50%);
            background: #FFFFFF;
            box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            z-index: 1;
            padding: 24px 56px;

            &:hover {
              cursor: pointer;
            }

            &:before {
              content: '';
              display: block;
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 0 8.5px 9px 8.5px;
              border-color: transparent transparent #ffffff transparent;
              position: absolute;
              top: -9px;
              bottom: auto;
              left: 0;
              right: 0;
              margin: auto;
            }

            .service_menu_item {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              margin-right: 48px;
              
              &:nth-last-child(2) {
                margin-right: 0;
              }

              img {
                display: block;
                width: 32px;
                margin-bottom: 4px;
              }

              span {
                display: block;
                text-align: center;
                font-size: 12px;
                line-height: 16px;
                color: #5C5C5C;
                font-weight: 400;
                white-space: nowrap;
                transition: color 0.2s ease 0s;
              }

              &:hover {
                cursor: pointer;

                span {
                  color: #FE6B01;
                  transition: color 0.2s ease 0s;
                }
              }
            }

            .site_search {
              position: absolute;
              top: 0;
              bottom: 0;
              left: auto;
              right: 0;
              margin: auto;
              width: 100%;
              height: 100%;
              background: #FAFAFA;
              box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
              border-radius: 6px;
              width: 0;
              padding: 24px 0 24px;
              transition: all 0.2s linear 0s;
              overflow: hidden;

              &.search_show {
                padding: 24px 36px 24px 40px;
                width: 100%;
                transition: all 0.2s linear 0s;
              }

              .site_search_input_wrapper {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                form {
                  width: 100%;
                }

                .site_search_input {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;

                  input {
                    appearance: none;
                    width: 100%;
                    height: 48px;
                    background: #FFFFFF;
                    border-top: 1px solid #EAEAEA;
                    border-left: 1px solid #EAEAEA;
                    border-right: none;
                    border-bottom: 1px solid #EAEAEA;
                    box-sizing: border-box;
                    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
                    border-radius: 8px 0 0 8px;
                    padding-left: 24px;
                  }

                  button {
                    appearance: none;
                    border-top: 1px solid #EAEAEA;
                    border-left: none;
                    border-right: 1px solid #EAEAEA;
                    border-bottom: 1px solid #EAEAEA;
                    background: #FE6B01;
                    font-size: 13px;
                    color: #FFFFFF;
                    height: 48px;
                    width: 72px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 0 8px 8px 0;

                    &:hover {
                      cursor: pointer;
                    }
                  }
                }
              }

              .site_search_close {
                margin-left: 12px;

                img {
                  display: block;
                  width: 24px;
                }
              }
            }
          }
        }
      }
    }

    .menu_function {
      display: flex;
      justify-content: space-between;
      align-items: normal;
      flex-direction: column;
      margin-left: 48px;

      ul {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        li {
          margin-right: 20px;

          &:last-of-type {
            margin-right: 0;
          }

          a {
            display: block;
            font-size: 12px;
            color: #5C5C5C;
            transition: color 0.2s ease 0s;

            &:hover {
              cursor: pointer;
              color: #FE6B01;
              transition: color 0.2s ease 0s;
            }
          }
        }
      }

      .function_buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;

        button,
        a {
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
          border-radius: 6px;
          color: #FFFFFF;
          font-weight: 600;
          font-size: 13px;
          height: 40px;
          text-align: center;
          appearance: none;
          border: none;
          padding: 0 16px;
          min-width: 96px;
          display: flex;
          justify-content: center;
          align-items: center;

          &:hover {
            cursor: pointer;
          }

          &.account_open {
            background: #FE6B01;
          }

          &.login {
            background: #272C84;
          }
        }

        .login_button {
          position: relative;
          margin-left: 16px;

          .login_popover {
            position: absolute;
            top: calc(100% + 9px);
            bottom: auto;
            left: auto;
            right: 0;
            margin: auto;
            background: #FFFFFF;
            z-index: 1;
            padding: 24px 0;
            border-radius: 6px;
            width: auto;
            box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1%);

            &:before {
              content: '';
              display: block;
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 0 8.5px 9px 8.5px;
              border-color: transparent transparent #ffffff transparent;
              position: absolute;
              top: -9px;
              bottom: auto;
              left: auto;
              right: 40px;
              margin: auto;
            }

            .login_wrapper {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .login_type {
                padding: 0 24px;
                border-right: 1px solid #EAEAEA;

                &:last-of-type {
                  border-left: none;
                }

                >div {
                  font-weight: 600;
                  font-size: 13px;
                  line-height: 18px;
                  color: #5C5C5C;
                  text-align: center;
                  margin-bottom: 16px;
                  white-space: nowrap
                }

                a {
                  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
                  border-radius: 6px;
                  color: #FFFFFF;
                  font-weight: 600;
                  font-size: 13px;
                  height: 40px;
                  text-align: center;
                  appearance: none;
                  border: none;
                  padding: 0 32px;
                  min-width: 152px;
                  height: 40px;
                  position: relative;
                  background: #272C84;
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  &:after {
                    content: '';
                    display: block;
                    width: 16px;
                    height: 16px;
                    background: url('../../assets/images/common/arrow_white_right.svg') center center no-repeat;
                    background-size: contain;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: auto;
                    right: 12px;
                    margin: auto;
                    pointer-events: none;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  // SP menu
  .header_functions {
    display: none;

    @media #{$small} {
      display: flex;
      justify-content: flex-end;
    }

    .icon {
      @media #{$small} {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        margin-right: psd(16);
      }

      &:last-child {
        @media #{$small} {
          margin-right: 0;
        }
      }

      img {
        @media #{$small} {
          display: block;
          width: psd(24);
          min-width: psd(24);
          height: psd(24);
          min-height: psd(24);
        }
      }

      span {
        @media #{$small} {
          font-size: psd(10);
          line-height: 1;
          display: block;
          text-align: center;
          white-space: nowrap;
          font-weight: 600;
          margin-top: 4px;
        }
      }

      &.account {
        span {
          @media #{$small} {
            color: #FE6B01;
          }
        }
      }

      &.login {
        span {
          @media #{$small} {
            color: #534DA1;
          }
        }

        .sp_login_popover {
          @media #{$small} {
            width: 100vw;
            position: absolute;
            top: calc(100% + 10px);
            bottom: auto;
            left: 0;
            right: 0;
            margin: auto;
            padding: psd(24) 0;
            background: #FFFFFF;
            border-radius: 6px;
          }

          &:before {
            @media #{$small} {
              content: '';
              display: block;
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 0 psd(8.5) psd(9) psd(8.5);
              border-color: transparent transparent #ffffff transparent;
              position: absolute;
              top: -#{psd(9)};
              bottom: auto;
              left: auto;
              right: psd(78);
              margin: auto;
            }
          }

          .sp_login_wrapper {
            @media #{$small} {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .sp_login_type {
              @media #{$small} {
                width: 50vw;
                padding: 0 psd(20);
                border-right: 1px solid #EAEAEA;
              }

              &:last-of-type {
                border-right: none;
              }

              >div {
                @media #{$small} {
                  font-weight: 600;
                  font-size: psd(12);
                  line-height: psd(18);
                  margin-bottom: 16px;
                  color: #5C5C5C;
                  text-align: center;
                  white-space: nowrap;
                }
              }

              a {
                @media #{$small} {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 40px;
                  background: #272C84;
                  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
                  border-radius: 6px;
                  color: #FFFFFF;
                  position: relative;
                  font-size: psd(13);
                  font-weight: 600;
                }

                &:after {
                  @media #{$small} {
                    content: '';
                    width: psd(16);
                    height: psd(16);
                    background: url('../../assets/images/common/arrow_white_right.svg') center center no-repeat;
                    background-size: contain;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: auto;
                    right: psd(12);
                    margin: auto;
                    pointer-events: none;
                  }
                }
              }
            }
          }
        }
      }

      &.menu {
        @media #{$small} {
          width: psd(40);
          color: #707070;
        }

        &.normal {
          img {
            @media #{$small} {
              width: psd(18);
              min-width: psd(18);
              height: auto;
              min-height: auto;
              margin: psd(4) 0;
            }
          }
        }
      }
    }
  }
}

::v-deep {
  #pc_serviceBooks {
    @media #{$small} {
      display: none;
    }
  }

  .service_book_wrapper {
    padding: 35px 15px;
    background-color: #FF6600;
    width: 900px;

    p {
      margin: 0;
      color: #FFFFFF;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 20px;
    }

    .service_book_buttons {
      display: flex;
      justify-content: space-between;
      align-items: center;

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #CCC;
        border-radius: 6px;
        background: linear-gradient(to bottom, #ffffff 0%, #dedede 100%);
        height: 69px;
        width: 48%;

        span {
          display: block;
          font-size: 16px;
          text-align: center;
          color: #333333;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>